export const HEALTH_STATUS = {
  BASELINE_INCOMPLETE: 'Baseline Incomplete'
};
